import {
  applyGuideTourRuntimeConfig,
  defineGuideTourConfig,
  setGuideTourTargetInteractionMapper,
} from '@/guide-tour/config'

export {
  GuideTourAppProvider,
  sellerGuideTourRegistry,
} from './GuideTourAppProvider'

import { mapGuideTourTargetInteractionClickedProps } from './utils/analytics-mappers'

export const guideTourConfig = defineGuideTourConfig({
  toursRoot: '.',

  observers: {
    // Detecção apenas: classe do overlay escuro dentro do shadow do dialog Hexa V2.
    // Não fecha modal — só informa à lib que ainda há modal aberta (waitForModalHidden).
    modalBackdropClass: 'backdrop',
    modalHostSelectors: ['hexa-v2-dialog', 'hexa-v2-modal', 'hexa-v2-drawer'],
    detectFullscreenBlockingOverlay: true,
  },

  ui: {
    /** Oculta "Novidade X de Y" no card; fila de tours na rota segue igual. */
    hideTourQueueLabel: true,
    // skippedStepNoticeMs: 5_000, // default da lib
  },

  analytics: {
    viewedEventName: 'Guide Tour Viewed',
    clickedEventName: 'Guide Tour Clicked',
  },

  // Runtime: GuideTourAppProvider → GuideTourProvider (registry, isFeatureFlagOn, onInteraction).
})

applyGuideTourRuntimeConfig(guideTourConfig)
setGuideTourTargetInteractionMapper(mapGuideTourTargetInteractionClickedProps)
